const ports : {[key : string] : number} = {
	https : 443,
	http : 80
}
class Url {
	protocol = ''
	auth = ''
	user = ''
	pass = ''
	host = ''
	port = -1
	hostname = ''
	hash = ''
	search = ''
	query : {[key : string] : string} = {}
	pathname = ''
	url = ''
	origin = ''
}

function inBrowser(){
	return typeof window !== 'undefined'
}

export function parseUrl (url : string) {
	let result = new Url()
	if (!url) {
		return result
	}
	let urls,hosts : string[], auths : string[],i : number,paths : string[], searchIndex : number, 
	searchs : string[],query : string[],hashIndex : number

	result.url = url

	//protocol fixed,such as  //cdn.com/jquery.js
	if (inBrowser()) {
		if(url.indexOf('//') === 0) {
			url = window.location.href.split('/')[0] + url
		} else if (url.indexOf('://') < 0 ){
			url = window.location.href.split('://')[0] + '://' + url
		}
	}

	//hash parse
	// result.hash = ''
	if(0 <= (hashIndex = url.indexOf('#'))){
		result.hash = url.slice(hashIndex + 1)
		url = url.slice(0,hashIndex)
	}

	//search parse
	if(0 <= (searchIndex = url.indexOf('?'))){
		result.search = url.slice(searchIndex + 1)
		url = url.slice(0,searchIndex)
		if (result.search) {
			searchs = result.search.split('&')
			for (i = searchs.length - 1; i >= 0; i--) {
				query = searchs[i].split('=')
				result.query[decodeURIComponent(query[0])] = decodeURIComponent(query[1] || '') 
			}
		}
	}

	//protocol parse
	urls = url.split('/')
	result.protocol = urls[0].toLowerCase().replace(/:$/,'')

	//host parse
	hosts = urls[2].split('@')  // auth host eg rob:abcd1234@www.domain.com:80
	
	if(hosts.length === 1){
		result.host = hosts[0]
	}else{
		result.auth = hosts[0]
		auths = result.auth.split(':')
		result.user = auths[0]
		result.pass = auths[1] || ''
		result.host = hosts[1]
	}

	hosts = result.host.split(':')
	if(hosts.length > 1){
		result.hostname = hosts[0]
		result.port = +hosts[1]
	}else{
		result.hostname = result.host
		result.port = ports[result.protocol] || result.port 
	}

	//path parse
	result.pathname = ''
	paths = urls.slice(3)
	if(paths.length > 0){
		result.pathname = '/' + paths.join('/')
	}

	//origin
	
	// result.origin = `${result.protocol || ''}://${result.host}`
	result.origin = result.host
	if (result.protocol) {
		result.origin = result.protocol + '://' + result.origin
	}
	return result
}